// @flow
import styled from 'styled-components';
import { py, px } from 'styled-components-spacing';

import theme from '@theme';
import Wrapper from '../Wrapper';


export const StyledCover = styled(Wrapper)`
  width: auto;
  height: 60px;
  box-sizing: border-box;
  cursor: pointer;

  font-family: 'Open Sans';
  font-size: 16px;

  ${theme.fontWeight.bold}

  background-color: transparent;
  border: 1px solid rgba(255, 255, 255, 0.5);

  transition: all 0.25s;

  color: ${theme.colors.white};

  display: flex;
  justify-content: center;
  align-items: center;

  ${theme.borderRadius.medium}

  text-decoration: none;

  ${py(0.5)}
  ${px(1)}

  &:active, &:hover {
    color: rgba(255, 255, 255, 0.7);
  }

  [disabled] {
    color: rgba(255, 255, 255, 0.5);
    pointer-events: none;
  }
`;
